import layout from '@/layout'

export default {
  path: '/search',
  component: layout,
  redirect: '/search/explore1',
  name: 'search',
  meta: {
    title: 'search',
    icon: 'search'
  },
  children: [
    {
      path: '/search/explore1',
      name: 'searchExplore1',
      component: () => import('@/views/search/explore1.vue'),
      meta: {
        title: 'searchExplore1',
        icon: 'search'
      }
    },
    {
      path: '/search/explore2',
      name: 'searchExplore2',
      component: () => import('@/views/search/explore2.vue'),
      meta: {
        title: 'searchExplore2',
        icon: 'search'
      }
    },
    {
      path: '/search/explore3',
      name: 'searchExplore3',
      component: () => import('@/views/search/explore3.vue'),
      meta: {
        title: 'searchExplore3',
        icon: 'search'
      }
    },
    {
      path: '/search/explore4',
      name: 'searchExplore4',
      component: () => import('@/views/search/explore4-v2.vue'),
      meta: {
        title: 'searchExplore4',
        icon: 'search'
      }
    },
    {
      path: '/search/explore5',
      name: 'searchExplore5',
      component: () => import('@/views/search/explore4.vue'),
      meta: {
        title: 'searchExplore5',
        icon: 'search'
      }
    },
    {
      // 新增独立的探索6路由，不复用探索5组件，避免后续业务开发时两个页面相互影响。
      path: '/search/explore6',
      name: 'searchExplore6',
      component: () => import('@/views/search/explore6.vue'),
      meta: {
        title: 'searchExplore6',
        icon: 'search'
      }
    },
    {
      // 新增独立的探索7路由，排在探索6之后，菜单顺序与该数组顺序一致。
      // 页面内容当前为空占位，后续补充业务时不需要再调整路由与导航配置。
      path: '/search/explore7',
      name: 'searchExplore7',
      component: () => import('@/views/search/explore7.vue'),
      meta: {
        title: 'searchExplore7',
        icon: 'search'
      }
    }
  ]
}
